export default function Logo({ dark = false }) {
  return (
    <span className="flex items-center gap-2" data-testid="brand-logo">
      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-600 shadow-sm">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 10v4" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
          <path d="M8 7v10" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
          <path d="M12 4v16" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
          <path d="M16 7v10" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
          <path d="M20 10v4" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
      </span>
      <span className={`text-lg font-bold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
        CogniTask
      </span>
    </span>
  );
}
